import axios from 'axios'
import apiUrl from '../../../constants'
import CryptoJS from 'crypto-js'
import {Validator} from 'vee-validate'
import VueElementLoading from 'vue-element-loading'
import PageTracker from '../../../common/PageTrackerHelper'

export default{
  name:'UpdateFlyerBarcode',
  components:{CryptoJS,Validator,VueElementLoading,PageTracker},
  mixins:[PageTracker],
  data: function(){
    return {
      shippingId:'',
      flyerBarcode:'',
      isLoading:false,
      userDataKey : '',
    }
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;

  },
  methods:{
    updateFlyerBarcode:function(){
      this.isLoading = true
      this.$validator.validateAll().then(res =>{
        if(this.flyerBarcode.length == 12 && (this.flyerBarcode.startsWith("RVPS") || this.flyerBarcode.startsWith("RVPM")
        || this.flyerBarcode.startsWith("RVPL") || this.flyerBarcode.startsWith("RVPN")))
        {
          var input = {
            'ShippingId':this.shippingId.trim(),
            'Flyerbarcode':this.flyerBarcode,
            "LastModifiedBy": this.localusermailid
          }
          axios({
            method:'POST',
            url:apiUrl.api_url + 'websupport/update/shipment/flyerbarcode',
            data:input
          }).then(result =>{
            this.isLoading = false
            if (result.data.code === 200) {
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.localuserid,
                username:this.localusermailid,
                meta: {
                  "event":"updateFlyerBarcode",
                  'ShippingId':this.shippingId.trim().toString(),
                  'Flyerbarcode':this.flyerBarcode
                }
              }
              this.PageTracker(TrackerInfo);
              this.$alertify.success(result.data.message)
            }else {
              this.$alertify.error(result.data.message)
            }
            this.reset();
          }).catch(err =>{
            this.isLoading = false
            console.log("Error Details", err);
            return false
          })
        }
        else if (!res) {
          this.isLoading = false
          this.$alertify.error("Invalid Input")
          return false
        }else {
          this.isLoading = false
          this.$alertify.error("FlyerBarcode should be Start with RVPS/RVPM/RVPL/RVPN and length should be 12");
      }
      }).catch(err =>{
        console.log("Error Details", err);
        return false
      })
    },
    UpperCaseFlyerBarcode(){
      var FlyerBarcode = this.flyerBarcode.toUpperCase()
      this.flyerBarcode = FlyerBarcode
    },
    reset(){
      this.$validator.reset()
      this.shippingId = ''
      this.flyerBarcode = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/UpdateFlyerBarcode/UpdateFlyerBarcode.component.js